import './paragraph-four-images-with-text-half.tpl.php';
import './style.scss';
import { addEllipsis } from '../../../jsPlugins/ellipsis';

jQuery($ => {
  addEllipsis($, '.paragraph-four-images-with-text-half h5');
  addEllipsis($, '.paragraph-four-images-with-text-half__description-one');
  addEllipsis($, '.paragraph-four-images-with-text-half__description-two');
});
